import type { ReversePurchaseOrderRequestProps, TransferPurchaseOrderRequestProps } from '@services/api/ocNf/types'
import type { TransferReversePurchaseOrderFormProps } from '../context/types'

export const parseTransferReversePurchaseOrderPayload = (formData: TransferReversePurchaseOrderFormProps | null) => {
  const payload: ReversePurchaseOrderRequestProps | TransferPurchaseOrderRequestProps = {
    routeParams: {
      filiCode: formData?.filiCode || '',
      competenceDate: formData?.competenceDate || ''
    },
    bodyParams: {
      supplierCode: formData?.supplierCode ? Number(formData?.supplierCode) : '',
      purchaseOrderNumber: formData?.purchaseOrderNumber ? Number(formData?.purchaseOrderNumber) : ''
    }
  }

  return payload
}
